import { hourMs } from "verdi-common/timeConstants";
import { generateUID } from "verdi-common/utils/HelperFunctions";

import { POLLING_FREQUENCIES, PollingFrequency, PollingRule } from "./constants";

export const RECENT_CONTACT_THRESHOLD = 24 * hourMs;

/**
 * Create a new polling rule
 */
export const createRule = (frequency: PollingFrequency, getDeviceIdsForPolling: () => string[]): PollingRule => ({
    id: generateUID(),
    frequency,
    getDeviceIdsForPolling,
});

/**
 * Get all the active rules. Rules with no devices to poll are not considered active.
 */
const getActiveRules = (rules: PollingRule[]): PollingRule[] =>
    rules.filter((r) => r.getDeviceIdsForPolling().length > 0);

/**
 * Get the highest frequency from the active rules
 */
export const getHighestActiveFrequency = (rules: PollingRule[]): PollingFrequency => {
    const activeRules = getActiveRules(rules);
    return activeRules.length > 0 ? Math.min(...activeRules.map((r) => r.frequency)) : POLLING_FREQUENCIES.DEFAULT;
};
